import { useEffect, useState } from 'react'

import { SL_Skeleton } from '../../../components/skeleton/SL_Skeleton'
import { SL_Table } from '../../../components/table/SL_Table'

import { displayMessage } from '../../../helpers/messages'
import './reports.css'

export const ReportTable = ({ columns, data, onShowMore, showMoreOptions, loading, height, limit, filters, central }) => {
    const [offset, setOffet] = useState(0)
    const [tableColumns, setTableColumns] = useState([])
    const [tableData, setTableData] = useState([])

    const getClasses = (idx) => {
        let classes = ' report-table-lines normal-case opacity-100 truncate text-ellipsis '
        const numberToRestOfOperation = 2
        if (idx == null || idx % numberToRestOfOperation == 0) return classes

        classes += 'rounded-[10px] bg-sl-gray-150'

        return classes
    }

    const showMoreAction = () => {
        const newOffset = offset + limit
        setOffet(newOffset)
        onShowMore({ offset: newOffset })
    }

    useEffect(() => {
        if (data) {
            setTableColumns(
                columns.map((col) => ({
                    ...col,
                    className: 'font-medium report-table-columns uppercase truncate text-ellipsis',
                    render: (checked, record, index, originNode) => {
                        if (col.custom_render) {
                            return col.custom_render(record)
                        }
                        return <div className="report-table-lines flex normal-case text-white items-center truncate text-ellipsis">{record?.[col.dataIndex] || '---'}</div>
                    },
                }))
            )
        }
        setTableData(data)
    }, [data])

    useEffect(() => {
        setOffet(0)
    }, [filters, central])
    return (
        <>
            {loading && <SL_Skeleton type="report" block active rows={10} />}
            {!loading && tableData && (
                    <SL_Table
                        type="report"
                        columns={tableColumns}
                        dataSource={tableData}
                        size="middle"
                        scroll={{
                            y: height,
                            x: 500,
                        }}
                        rowHoverable={false}
                        rowClassName={(record, index) => {
                            return getClasses(index + 1)
                        }}
                        pagination={false}
                        footer={() =>
                            showMoreOptions ? (
                                <div className="flex justify-center items-center cursor-pointer" onClick={() => showMoreAction()}>
                                    {displayMessage('SHOW_MORE')}
                                </div>
                            ) : null
                        }
                    />
            )}
        </>
    )
}
